import React from 'react';

import { WpIllustration, Illustrations } from 'Wpds/components/illustration';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = {
  type?: string;
  width?: string;
  height?: string;
  className?: string;
};

const CharmaLogo = (props: Props) => {
  const { tr } = useTranslation();
  let logo = Illustrations.pi_logo_full_red_with_text;
  if (props.type === 'icon') {
    logo = Illustrations.pi_logo_circle_red;
  }
  if (props.type === 'long-white') {
    logo = Illustrations.pi_logo_full_white_with_text;
  }

  return <WpIllustration src={logo} alt={tr('perform.logos.predictive_index.alt')} {...props} />;
};

export default CharmaLogo;
